import { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import HowItWorks from "./components/HowItWorks";
import Preloader from "./components/Preloader";
import Contact from "./pages/Contact";
import WhyUs from "./components/WhyUs";
import CTASection from "./components/CTASection";
import About from "./components/About";
import Footer from "./components/Footer";
import QRScanner from "./components/qrScanner/qrScan";

function Home() {
  return (
    <>
      <Hero />
      <Services />
      <HowItWorks />
      <WhyUs />
      <CTASection />
    </>
  );
}

// 🔥 YE IMPORTANT PART HAI
function Layout({ loading, setLoading }) {
  const location = useLocation();

  const isScanPage = location.pathname === "/scan";

  return (
    <>
      {/* ❌ Navbar hide on scan page */}
      {!isScanPage && <Navbar />}

      {/* ❌ Preloader bhi hide */}
      {loading && !isScanPage && (
        <Preloader onFinish={() => setLoading(false)} />
      )}

      {/* Pages */}
      {(!loading || isScanPage) && (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/scan" element={<QRScanner />} />
        </Routes>
      )}

      {/* ❌ Footer hide */}
      {!isScanPage && <Footer />}
    </>
  );
}

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <Router>
      <Layout loading={loading} setLoading={setLoading} />
    </Router>
  );
}

export default App;